ikart.webshop.product_ui.ProductView =  class {
	/* Options:
		- View Type
		- Products Section Wrapper,
		- Item Group: If its an Item Group page
		- page_length: cap the number of products fetched (e.g. a single row on
		  the home page). Falls back to the Webshop Settings page size.
		- disable_scroll_paging: never append more products on scroll. Needed
		  wherever the grid is a fixed-size teaser rather than the catalogue —
		  a page_length alone would still grow as the user scrolls.
		- max_products: hard cap on how many cards are rendered. page_length is
		  only a query hint — the server can hand back MORE rows than asked for
		  (manual product groups pull their missing members in after the page
		  slice), so a grid that must stay exactly one row caps here as well.
	*/
	constructor(options) {
		Object.assign(this, options);
		this.preference = this.view_type;
		this.is_loading_more = false;
		this.has_more_products = false;
		this.next_start = 0;
		this.mobile_page_length = 12;
		this.make();
	}

	make(from_filters=false) {
		this.products_section.empty();
		$(".product-paging-area").remove();
		this.prepare_toolbar();
		this.get_item_filter_data(from_filters);
	}

	prepare_toolbar() {
		const should_render_search = this.should_render_toolbar_search();
		if (!should_render_search) {
			return;
		}

		this.products_section.append(`
			<div class="toolbar product-toolbar d-flex align-items-center"></div>
		`);

		if (should_render_search) {
			this.prepare_search();
			this.bind_product_search_action();
			new ikart.webshop.product_ui.ProductSearch();
		}
	}

	should_render_toolbar_search() {
		return !document.querySelector(".imek-navbar-search #search-box");
	}

	prepare_view_toggler() {
		return;
	}

	get_item_filter_data(from_filters=false, bind_filter_actions=!from_filters) {
		// Get and render all Product related views
		let me = this;
		this.from_filters = from_filters;
		let args = this.get_query_filters();

		this.disable_view_toggler(true);
		this.render_loading_skeletons();

		const cached_response = this.get_cached_product_response(args);
		if (cached_response) {
			this.handle_product_filter_response(cached_response, bind_filter_actions);
			this.disable_view_toggler(false);
			return;
		}

		frappe.call({
			method: "ikart.webshop.api.get_product_filter_data",
			args: {
				query_args: args
			},
			callback: function(result) {
				me.set_cached_product_response(args, result);
				me.handle_product_filter_response(result, bind_filter_actions);
				me.disable_view_toggler(false);
			}
		});
	}

	handle_product_filter_response(result, bind_filter_actions) {
		if (!result || result.exc || !result.message || result.message.exc) {
			this.products = [];
			this.product_count = 0;
			this.clear_product_results();
			this.render_no_products_section(true);
			return;
		}

		this.products_section.find(".sub-category-container").remove();
		// Webshop Category pages render subcategories as image tiles (.imek-cat-subtiles,
		// see category_hero.html), so skip the redundant text pills there. Item Group
		// listings (no image tiles) keep the pills.
		if (this.item_group && !this.webshop_category && result.message["sub_categories"].length) {
			this.render_item_sub_categories(result.message["sub_categories"]);
		}

		if (!result.message["items"].length) {
			this.products = [];
			this.product_count = 0;
			this.clear_product_results();
			this.render_no_products_section();
		} else {
			this.seen_product_result_keys = new Set();
			this.products = this.cap_products(
				this.filter_new_product_results(result.message["items"])
			);
			this.product_count = result.message["items_count"];
			this.product_settings = result.message["settings"];
			this.update_scroll_paging_state(
				this.products.length,
				this.product_count,
				this.product_settings,
				result.message.next_start
			);
			this.clear_product_results();

			this.re_render_discount_filters(
				result.message["filters"].discount_filters,
				!bind_filter_actions
			);

			if (this.preference === "List View") {
				this.render_list_view(this.products, this.product_settings);
			} else {
				this.render_grid_view(this.products, this.product_settings);
			}
		}

		if (bind_filter_actions) {
			this.bind_filters();
			this.restore_filters_state();
		}

		this.add_paging_section(result.message["settings"]);
	}

	cap_products(items) {
		// Applied after grouping, so the cap holds whatever the server returned.
		// product_count is left alone: it is the real catalogue total.
		const max = cint(this.max_products);
		return max > 0 ? items.slice(0, max) : items;
	}

	clear_product_results() {
		this.products_section.find(".product-results-area, .product-empty-state, .product-skeleton-area").remove();
	}

	disable_view_toggler(disable=false) {
		$('#list').prop('disabled', disable);
		$('#image-view').prop('disabled', disable);
	}

	render_grid_view(items, settings) {
		// loop over data and add grid html to it
		let me = this;
		this.prepare_product_area_wrapper("grid");

		new ikart.webshop.product_ui.ProductGrid({
			items: items,
			products_section: $("#products-grid-area"),
			settings: settings,
			preference: me.preference,
			append: false
		});
	}

	render_list_view(items, settings) {
		let me = this;
		this.prepare_product_area_wrapper("list");

		new ikart.webshop.product_ui.ProductList({
			items: items,
			products_section: $("#products-list-area"),
			settings: settings,
			preference: me.preference,
			append: false
		});
	}

	prepare_product_area_wrapper(view) {
		let left_margin = view == "list" ? "ml-2" : "";
		// no negative top margin: without a sub-category strip above, the grid
		// would overlap and clip the page title (e.g. category pages without
		// child categories)
		let top_margin = view == "list" ? "mt-6" : "";
		return this.products_section.append(`
			<div class="product-results-area">
				<div id="products-${view}-area" class="row products-list ${ top_margin } ${ left_margin }" itemscope itemtype="https://schema.org/Product"></div>
			</div>
		`);
	}

	get_query_filters() {
		const filters = frappe.utils.get_query_params();
		let {field_filters, attribute_filters} = filters;

		field_filters = this.parse_filter_param(field_filters);
		attribute_filters = this.parse_filter_param(attribute_filters);

		return {
			field_filters: field_filters,
			attribute_filters: attribute_filters,
			item_group: this.item_group || filters.item_group || null,
			webshop_category: this.webshop_category || filters.webshop_category || null,
			search: filters.search || "",
			start: filters.start || null,
			from_filters: this.from_filters || false,
			page_length: this.page_length_override || this.get_mobile_page_length()
		};
	}

	parse_filter_param(value) {
		if (!value) {
			return {};
		}
		if (typeof value === "object") {
			return value;
		}
		try {
			return JSON.parse(value) || {};
		} catch (e) {
			return {};
		}
	}

	get_mobile_page_length() {
		return window.matchMedia("(max-width: 767.98px)").matches ? this.mobile_page_length : null;
	}

	get_product_cache_key(args) {
		return null;
	}

	get_cached_product_response(args) {
		const key = this.get_product_cache_key(args);
		if (!key) {
			return null;
		}

		try {
			const cached = JSON.parse(sessionStorage.getItem(key) || "null");
			if (cached && cached.expires > Date.now()) {
				return cached.result;
			}
		} catch (e) {
			sessionStorage.removeItem(key);
		}

		return null;
	}

	set_cached_product_response(args, result) {
		const key = this.get_product_cache_key(args);
		if (!key || !result || result.exc || !result.message || result.message.exc) {
			return;
		}

		try {
			sessionStorage.setItem(key, JSON.stringify({
				result,
				expires: Date.now() + 60000
			}));
		} catch (e) {
			sessionStorage.removeItem(key);
		}
	}

	render_loading_skeletons() {
		this.clear_product_results();
		// A capped teaser grid must not flash three rows of placeholders and then
		// collapse to one — the skeletons stand in for the cards that will land.
		const default_count = window.matchMedia("(max-width: 767.98px)").matches ? 6 : 9;
		const skeleton_count = cint(this.max_products) > 0
			? Math.min(cint(this.max_products), default_count)
			: default_count;
		const skeletons = Array.from({length: skeleton_count}).map(() => `
			<div class="item-card product-skeleton-card">
				<div class="card text-left">
					<div class="product-skeleton product-skeleton-image"></div>
					<div class="card-body">
						<div class="product-skeleton product-skeleton-line product-skeleton-title"></div>
						<div class="product-skeleton product-skeleton-line"></div>
						<div class="product-skeleton product-skeleton-button"></div>
					</div>
				</div>
			</div>
		`).join("");

		this.products_section.append(`
			<div class="product-results-area product-skeleton-area">
				<div class="row products-list">
					${ skeletons }
				</div>
			</div>
		`);
	}

	add_paging_section(settings) {
		$(".product-paging-area").remove();

		if (this.disable_scroll_paging) {
			return;
		}

		if (this.products && this.products.length) {
			const paging_html = `
				<div class="product-paging-area mt-4 text-center" aria-live="polite">
					<div class="scroll-pagination-loading hidden">
						${ __("Loading more products...") }
					</div>
					<div class="scroll-pagination-end ${ this.has_more_products ? "hidden" : "" }">
						${ __("End of products") }
					</div>
				</div>
			`;

			$(".page_content").append(paging_html);
			this.bind_scroll_paging_action();
		}
	}

	update_scroll_paging_state(items_on_page, product_count, settings, next_start) {
		const query_params = frappe.utils.get_query_params();
		const start = query_params.start ? cint(JSON.parse(query_params.start)) : 0;

		this.page_length = settings.products_per_page || items_on_page || 0;
		this.next_start = Number.isFinite(Number(next_start))
			? cint(next_start)
			: start + items_on_page;
		this.product_count = product_count || 0;
		this.has_more_products = !this.disable_scroll_paging && this.next_start < this.product_count;
		this.is_loading_more = false;
	}

	bind_scroll_paging_action() {
		if (this.scroll_paging_bound) {
			return;
		}

		this.scroll_paging_bound = true;
		let scroll_tick_pending = false;
		$(window).on("scroll.product-scroll-pagination resize.product-scroll-pagination", () => {
			if (scroll_tick_pending) {
				return;
			}
			scroll_tick_pending = true;
			window.requestAnimationFrame(() => {
				scroll_tick_pending = false;
				this.maybe_load_more_products();
			});
		});
		this.maybe_load_more_products();
	}

	maybe_load_more_products() {
		if (this.is_loading_more || !this.has_more_products || !this.products || !this.products.length) {
			return;
		}

		const scroll_bottom = $(window).scrollTop() + $(window).height();
		const trigger_point = $(document).height() - 700;

		if (scroll_bottom >= trigger_point) {
			this.load_more_products();
		}
	}

	load_more_products() {
		const me = this;
		const args = this.get_query_filters();
		args.start = this.next_start;
		args.from_filters = false;

		this.is_loading_more = true;
		$(".scroll-pagination-loading").removeClass("hidden");
		$(".scroll-pagination-end").addClass("hidden");

		frappe.call({
			method: "ikart.webshop.api.get_product_filter_data",
			args: {
				query_args: args
			},
			callback: function(result) {
				if (!result || result.exc || !result.message || result.message.exc || !result.message["items"].length) {
					me.has_more_products = false;
				} else {
					const raw_next_items = result.message["items"];
					const next_items = me.filter_new_product_results(raw_next_items);
					me.products = (me.products || []).concat(next_items);
					me.product_count = result.message["items_count"];
					me.product_settings = result.message["settings"];
					me.next_start = Number.isFinite(Number(result.message.next_start))
						? cint(result.message.next_start)
						: me.next_start + raw_next_items.length;
					me.has_more_products = me.next_start < me.product_count;

					if (next_items.length) {
						if (me.preference === "List View") {
							me.append_list_view(next_items, me.product_settings);
							if ($("#products-grid-area").length) {
								me.append_grid_view(next_items, me.product_settings);
							}
						} else {
							me.append_grid_view(next_items, me.product_settings);
							if ($("#products-list-area").length) {
								me.append_list_view(next_items, me.product_settings);
							}
						}
					}
				}

				me.is_loading_more = false;
				$(".scroll-pagination-loading").toggleClass("hidden", !me.has_more_products);
				$(".scroll-pagination-end").toggleClass("hidden", me.has_more_products);

				if (me.has_more_products) {
					me.maybe_load_more_products();
				}
			}
		});
	}

	get_product_result_key(item) {
		if (!item) {
			return "";
		}

		if (item.product_group_key) {
			return `group:${item.product_group_key}`;
		}

		return `item:${item.item_code || item.name || item.route || ""}`;
	}

	filter_new_product_results(items) {
		if (!this.seen_product_result_keys) {
			this.seen_product_result_keys = new Set();
		}

		return (items || []).filter(item => {
			const key = this.get_product_result_key(item);
			if (!key || this.seen_product_result_keys.has(key)) {
				return false;
			}

			this.seen_product_result_keys.add(key);
			return true;
		});
	}

	append_grid_view(items, settings) {
		if (!$("#products-grid-area").length) {
			this.render_grid_view(items, settings);
			return;
		}

		new ikart.webshop.product_ui.ProductGrid({
			items: items,
			products_section: $("#products-grid-area"),
			settings: settings,
			preference: this.preference,
			append: true
		});
	}

	append_list_view(items, settings) {
		if (!$("#products-list-area").length) {
			this.render_list_view(items, settings);
			return;
		}

		new ikart.webshop.product_ui.ProductList({
			items: items,
			products_section: $("#products-list-area"),
			settings: settings,
			preference: this.preference,
			append: true
		});
	}

	prepare_search() {
		const query_params = frappe.utils.get_query_params();
		const search_value = query_params.search || "";
		const attr = ikart.webshop.product_ui.attr;
		const search_width = this.hide_view_toggler ? "col-12" : "col-8";
		$(".toolbar").append(`
			<div class="input-group ${ search_width } p-0 product-search-wrapper">
				<div class="dropdown w-100" id="dropdownMenuSearch">
					<label class="sr-only" for="search-box">${ __("Search products") }</label>
					<input type="search" name="query" id="search-box" class="form-control font-md"
						placeholder="${__("Search for Products")}"
						value="${ attr(search_value) }" autocomplete="off"
						aria-label="${ __("Search products") }"
						aria-controls="search-results-container" aria-expanded="false">
					<div class="search-icon">
						<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
							fill="none"
							stroke="currentColor" stroke-width="2" stroke-linecap="round"
							stroke-linejoin="round"
							class="feather feather-search">
							<circle cx="11" cy="11" r="8"></circle>
							<line x1="21" y1="21" x2="16.65" y2="16.65"></line>
						</svg>
					</div>
					<button type="button" class="product-search-clear ${ search_value ? '' : 'hidden' }"
						aria-label="${ __("Clear search") }">
						&times;
					</button>
					<!-- Results dropdown rendered in product_search.js -->
				</div>
			</div>
		`);
	}

	bind_product_search_action() {
		let me = this;
		const $search = $("#search-box");
		const $clear = $(".product-search-clear");

		const update_clear_button = () => {
			$clear.toggleClass("hidden", !($search.val() || "").trim());
		};

		const update_route = (search_term) => {
			const query_params = frappe.utils.get_query_params();
			const current_search = query_params.search || "";

			if (search_term) {
				query_params.search = search_term;
			} else {
				delete query_params.search;
			}
			query_params.start = 0;

			if (search_term === current_search) {
				update_clear_button();
				return;
			}

			const query_string = me.get_query_string(query_params);
			window.history.pushState(
				"product-search",
				"",
				`${location.pathname}${query_string ? "?" + query_string : ""}`
			);

			me.from_filters = false;
			me.get_item_filter_data(false, false);
			update_clear_button();
		};

		const run_search = (force=false) => {
			const search_term = ($search.val() || "").trim();
			if (!force && search_term && search_term.length < 2) {
				if (frappe.utils.get_query_params().search) {
					update_route("");
				}
				update_clear_button();
				return;
			}

			update_route(search_term);
		};

		const debounced_search = frappe.utils.debounce(() => run_search(), 350);

		$search.off(".product-list-search").on("input.product-list-search", () => {
			update_clear_button();
			debounced_search();
		});

		$search.on("keydown.product-list-search", (event) => {
			if (event.key === "Enter") {
				event.preventDefault();
				run_search(true);
				$("#search-results-container").addClass("hidden");
				$search.attr("aria-expanded", "false");
			} else if (event.key === "Escape") {
				$("#search-results-container").addClass("hidden");
				$search.attr("aria-expanded", "false");
			}
		});

		$clear.off(".product-list-search").on("click.product-list-search", () => {
			$search.val("");
			run_search(true);
			$search.trigger("input").focus();
		});

		this.products_section.off("click.product-empty-search").on(
			"click.product-empty-search",
			".product-empty-clear-search",
			() => {
				$search.val("");
				run_search(true);
				$search.focus();
			}
		);

		update_clear_button();
	}

	render_view_toggler() {
		return;
	}

	bind_view_toggler_actions() {
		let me = this;
		$("#list").click(function() {
			let $btn = $(this);
			$btn.removeClass('btn-primary');
			$btn.addClass('btn-primary');
			$btn.attr('aria-pressed', 'true');
			$(".btn-grid-view").removeClass('btn-primary').attr('aria-pressed', 'false');

			me.preference = "List View";
			if (!$("#products-list-area").length && me.products) {
				me.render_list_view(me.products, me.product_settings);
			}
			$("#products-grid-area").addClass("hidden");
			$("#products-list-area").removeClass("hidden");
			localStorage.setItem("product_view", "List View");
		});

		$("#image-view").click(function() {
			let $btn = $(this);
			$btn.removeClass('btn-primary');
			$btn.addClass('btn-primary');
			$btn.attr('aria-pressed', 'true');
			$(".btn-list-view").removeClass('btn-primary').attr('aria-pressed', 'false');

			me.preference = "Grid View";
			if (!$("#products-grid-area").length && me.products) {
				me.render_grid_view(me.products, me.product_settings);
			}
			$("#products-list-area").addClass("hidden");
			$("#products-grid-area").removeClass("hidden");
			localStorage.setItem("product_view", "Grid View");
		});
	}

	set_view_state() {
		if (this.preference === "List View") {
			$("#list").addClass('btn-primary').attr('aria-pressed', 'true');
			$("#image-view").removeClass('btn-primary').attr('aria-pressed', 'false');
		} else {
			$("#image-view").addClass('btn-primary').attr('aria-pressed', 'true');
			$("#list").removeClass('btn-primary').attr('aria-pressed', 'false');
		}
	}

	bind_paging_action() {
		let me = this;
		$('.btn-prev, .btn-next').click((e) => {
			const $btn = $(e.target);
			me.from_filters = false;

			$btn.prop('disabled', true);
			const start = $btn.data('start');

			let query_params = frappe.utils.get_query_params();
			query_params.start = start;
			let path = window.location.pathname + '?' + frappe.utils.get_url_from_dict(query_params);
			window.history.pushState('paging', '', path);
			me.get_item_filter_data(false, false);
		});
	}

	re_render_discount_filters(filter_data, bind_discount_action=false) {
		this.get_discount_filter_html(filter_data);
		if (bind_discount_action) {
			// Discount filters are replaced with the product results.
			// Initial page load binds them through bind_filters().
			this.bind_discount_filter_action();
		}
		// discount filters are rendered with Items (later)
		// unlike the other filters
		this.restore_discount_filter();
	}

	get_discount_filter_html(filter_data) {
		$("#discount-filters").remove();
		if (filter_data) {
			$("#product-filters").append(`
				<div id="discount-filters" class="mb-4 filter-block pb-5">
					<div class="filter-label mb-3">${ __("Discounts") }</div>
				</div>
			`);

			let html = `<div class="filter-options">`;
			filter_data.forEach(filter => {
				html += `
					<div class="checkbox">
						<label data-value="${ filter[0] }">
							<input type="radio"
								class="product-filter discount-filter"
								name="discount" id="${ filter[0] }"
								data-filter-name="discount"
								data-filter-value="${ filter[0] }"
								style="width: 14px !important"
							>
								<span class="label-area" for="${ filter[0] }">
									${ filter[1] }
								</span>
						</label>
					</div>
				`;
			});
			html += `</div>`;

			$("#discount-filters").append(html);
		}
	}

	restore_discount_filter() {
		const filters = frappe.utils.get_query_params();
		let field_filters = filters.field_filters;
		if (!field_filters) return;

		field_filters = JSON.parse(field_filters);

		if (field_filters && field_filters["discount"]) {
			const values = field_filters["discount"];
			const selector = values.map(value => {
				return `input[data-filter-name="discount"][data-filter-value="${value}"]`;
			}).join(',');
			$(selector).prop('checked', true);
			this.field_filters = field_filters;
		}
	}

	bind_discount_filter_action() {
		let me = this;
		$('.discount-filter').off('change.product-discount-filter').on('change.product-discount-filter', (e) => {
			const $checkbox = $(e.target);
			const is_checked = $checkbox.is(':checked');

			const {
				filterValue: filter_value
			} = $checkbox.data();

			delete this.field_filters["discount"];

			if (is_checked) {
				this.field_filters["discount"] = [];
				this.field_filters["discount"].push(filter_value);
			}

			if (this.field_filters["discount"].length === 0) {
				delete this.field_filters["discount"];
			}

			me.change_route_with_filters();
		});
	}

	bind_filters() {
		let me = this;
		this.field_filters = {};
		this.attribute_filters = {};

		$('.product-filter').off('change.product-filter').on('change.product-filter', (e) => {
			me.from_filters = true;

			const $checkbox = $(e.target);
			const is_checked = $checkbox.is(':checked');

			if ($checkbox.is('.attribute-filter')) {
				const {
					attributeName: attribute_name,
					attributeValue: attribute_value
				} = $checkbox.data();

				if (is_checked) {
					this.attribute_filters[attribute_name] = this.attribute_filters[attribute_name] || [];
					this.attribute_filters[attribute_name].push(attribute_value);
				} else {
					this.attribute_filters[attribute_name] = this.attribute_filters[attribute_name] || [];
					this.attribute_filters[attribute_name] = this.attribute_filters[attribute_name].filter(v => v !== attribute_value);
				}

				if (this.attribute_filters[attribute_name].length === 0) {
					delete this.attribute_filters[attribute_name];
				}
			} else if ($checkbox.is('.field-filter') || $checkbox.is('.discount-filter')) {
				const {
					filterName: filter_name,
					filterValue: filter_value
				} = $checkbox.data();

				if ($checkbox.is('.discount-filter')) {
					// clear previous discount filter to accomodate new
					delete this.field_filters["discount"];
				}
				if (is_checked) {
					this.field_filters[filter_name] = this.field_filters[filter_name] || [];
					if (!in_list(this.field_filters[filter_name], filter_value)) {
						this.field_filters[filter_name].push(filter_value);
					}
				} else {
					this.field_filters[filter_name] = this.field_filters[filter_name] || [];
					this.field_filters[filter_name] = this.field_filters[filter_name].filter(v => v !== filter_value);
				}

				if (this.field_filters[filter_name].length === 0) {
					delete this.field_filters[filter_name];
				}
			}

			me.change_route_with_filters();
		});

		// bind filter lookup input box
		$('.filter-lookup-input').off('keydown.product-filter-lookup').on('keydown.product-filter-lookup', frappe.utils.debounce((e) => {
			const $input = $(e.target);
			const keyword = ($input.val() || '').toLowerCase();
			const $filter_options = $input.next('.filter-options');

			$filter_options.find('.filter-lookup-wrapper').show();
			$filter_options.find('.filter-lookup-wrapper').each((i, el) => {
				const $el = $(el);
				const value = $el.data('value').toLowerCase();
				if (!value.includes(keyword)) {
					$el.hide();
				}
			});
		}, 300));
	}

	change_route_with_filters() {
		let route_params = frappe.utils.get_query_params();
		const item_group = route_params.item_group || null;
		const webshop_category = route_params.webshop_category || null;

		let start = this.if_key_exists(route_params.start) || 0;
		if (this.from_filters) {
			start = 0; // show items from first page if new filters are triggered
		}

		const query_string = this.get_query_string({
			start: start,
			search: route_params.search,
			field_filters: JSON.stringify(this.if_key_exists(this.field_filters)),
			attribute_filters: JSON.stringify(this.if_key_exists(this.attribute_filters)),
			item_group: item_group,
			webshop_category: webshop_category,
		});
		window.history.pushState('filters', '', `${location.pathname}?` + query_string);

		$('.page_content input').prop('disabled', true);

		this.make(true);
		$('.page_content input').prop('disabled', false);
	}

	restore_filters_state() {
		const filters = frappe.utils.get_query_params();
		let {field_filters, attribute_filters} = filters;

		if (field_filters) {
			field_filters = this.parse_filter_param(field_filters);
			for (let fieldname in field_filters) {
				const values = Array.isArray(field_filters[fieldname])
					? field_filters[fieldname]
					: [field_filters[fieldname]];
				const selector = values.map(value => {
					return `input[data-filter-name="${fieldname}"][data-filter-value="${value}"]`;
				}).join(',');
				$(selector).prop('checked', true);
			}
			this.field_filters = field_filters;
		}
		if (attribute_filters) {
			attribute_filters = this.parse_filter_param(attribute_filters);
			for (let attribute in attribute_filters) {
				const values = Array.isArray(attribute_filters[attribute])
					? attribute_filters[attribute]
					: [attribute_filters[attribute]];
				const selector = values.map(value => {
					return `input[data-attribute-name="${attribute}"][data-attribute-value="${value}"]`;
				}).join(',');
				$(selector).prop('checked', true);
			}
			this.attribute_filters = attribute_filters;
		}
	}

	render_no_products_section(error=false) {
		const search_term = frappe.utils.get_query_params().search || "";
		const escaped_search = frappe.utils.escape_html(search_term);
		let error_section = `
			<div class="product-empty-state mt-4 w-100 alert alert-error font-md">
				${ __("Something went wrong. Please refresh or contact us.") }
			</div>
		`;
		let no_results_section = `
			<div class="product-empty-state cart-empty frappe-card mt-4">
				<div class="cart-empty-state">
					<img src="/assets/ikart/images/cart-empty-state.png" alt="Empty Cart">
				</div>
				<div class="cart-empty-message mt-4">
					${ search_term
						? `${ __("No products found for") } <strong>${ escaped_search }</strong>`
						: __("No products found") }
				</div>
				${ search_term
					? `<button type="button" class="btn btn-sm btn-outline-secondary mt-3 product-empty-clear-search">${ __("Clear search") }</button>`
					: "" }
			</div>
		`;

		this.products_section.append(error ? error_section : no_results_section);
	}

	render_item_sub_categories(categories) {
		if (categories && categories.length) {
			let sub_group_html = `
				<div class="sub-category-container scroll-categories">
			`;

			categories.forEach(category => {
				const label = category.category_name || category.name || "";
				sub_group_html += `
					<a href="/${ category.route || '#' }" style="text-decoration: none;">
						<div class="category-pill">
							${ label }
						</div>
					</a>
				`;
			});
			sub_group_html += `</div>`;

			$("#product-listing").prepend(sub_group_html);
		}
	}

	get_query_string(object) {
		const url = new URLSearchParams();
		for (let key in object) {
			const value = object[key];
			if (value) {
				url.append(key, value);
			}
		}
		return url.toString();
	}

	if_key_exists(obj) {
		return obj && Object.keys(obj).length ? obj : undefined;
	}
};
